<template>
  <div id="app">
    <BrowserRecommend v-if="isIE" />
    <router-view v-else />
  </div>
</template>

<script>
import { isIE } from './utils'
import BrowserRecommend from './components/BrowserRecommend'

export default {
  name: 'App',
  data () {
    return {
      isIE: isIE()
    }
  },
  components: {
    BrowserRecommend
  }
}
</script>

<style lang="scss">
html, body {
  height: 100%;
  padding: 0;
  margin: 0;
  overflow-y: hidden;
  overflow-x: auto;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  min-width: 1280px;
}
</style>
